export interface DataChangeEmitPayload<T> {
  data: T,
  who: DataChangeEmitWho,
  what: DataChangeEmitWhat,
} 

export enum DataChangeEmitWho {
  Self,
  Sync
}

export enum DataChangeEmitWhat {
  Create,
  Update,
  Delete,
  Download
}